import React from "react";
import { Badge } from "@/components/ui/badge";
import { Card, CardContent } from "@/components/ui/card";
export default function PolicyOverview() {
  return <section id="政策概览" className="bg-background pt-[120px] pb-24 px-6 md:px-12">
      <div className="max-w-4xl mx-auto flex flex-col items-center">
        <h1 className="text-[48px] font-bold font-sans text-foreground mb-6 text-center tracking-tight">
          听力通 隐私政策
        </h1>
        
        <Badge variant="secondary" className="bg-primary/10 text-primary hover:bg-primary/20 border-transparent rounded-[16px] px-5 py-2 mb-16 text-sm md:text-base font-medium shadow-none">最后更新日期：2026年4月15日</Badge>

        <Card className="w-full rounded-[24px] border-2 border-muted shadow-xl shadow-black/5 bg-card overflow-hidden">
          <CardContent className="p-8 md:p-12">
            <div className="space-y-10 text-foreground/80 font-sans">
              <div className="space-y-4">
                <p className="text-[18px] leading-[1.8]">
                  欢迎您使用听力通！我们非常重视您的隐私保护和个人信息安全。本《隐私政策》旨在向您详细阐述我们在您使用听力通产品及服务时，如何收集、使用、保存、共享和转让您的个人信息，以及您如何行使您的隐私权利。我们承诺将按业界成熟的安全标准，采取相应的安全保护措施来保护您的个人信息。请您在继续使用我们的服务前，仔细阅读并充分理解本政策的全部内容。
                </p>
              </div>

              <div className="space-y-4">
                <h2 className="text-[24px] font-bold text-foreground">一、我们如何收集和使用您的个人信息</h2>
                <p className="text-[18px] leading-[1.8]">在您使用听力通的过程中，我们会根据合法、正当、必要的原则，收集您在使用服务时主动提供的或因为使用服务而产生的信息：</p>
                <ul className="list-disc pl-6 space-y-3 text-[18px] leading-[1.8]">
                  <li><strong>账号信息：</strong>当您注册听力通账号时，我们会收集您的手机号码或邮箱地址，用于身份验证和账号管理。</li>
                  <li><strong>学习数据：</strong>为了提供逐句精听和智能记忆功能，我们会记录您的学习进度、生词本内容、听力练习时长等数据。</li>
                  <li><strong>设备信息：</strong>为了保障软件运行安全和多端同步，我们会收集您的设备型号、操作系统版本、唯一设备标识符等。</li>
                  <li><strong>音频处理：</strong>当您导入音频进行AI识别时，我们会在云端或本地进行处理。我们承诺音频文件仅用于为您提供识别和翻译服务。</li>
                </ul>
              </div>

              <div className="space-y-4">
                <h2 className="text-[24px] font-bold text-foreground">二、我们如何共享、转让、公开披露您的个人信息</h2>
                <p className="text-[18px] leading-[1.8]">我们不会与听力通以外的任何公司、组织和个人分享您的个人信息，除非获得您的明确同意或法律法规另有规定。</p>
              </div>

              <div className="space-y-4">
                <h2 className="text-[24px] font-bold text-foreground">三、您的权利</h2>
                <p className="text-[18px] leading-[1.8]">按照中国相关的法律、法规、标准，我们保障您对自己的个人信息行使访问、更正、删除、注销账号等权利。您可以通过应用内的设置页面或联系我们的客服邮箱进行操作。</p>
              </div>

              <div className="space-y-4">
                <h2 className="text-[24px] font-bold text-foreground">四、联系我们</h2>
                <p className="text-[18px] leading-[1.8]">如果您对本隐私政策有任何疑问、意见或建议，通过以下方式与我们联系：</p>
                <p className="text-[18px] leading-[1.8] font-medium text-foreground">邮箱：service@listenmaster.cloud</p>
              </div>
            </div>
          </CardContent>
        </Card>
      </div>
    </section>;
}